import { gql } from '__generated__'

export const PinCandidateGroupNote = gql(/* GraphQL */ `
    mutation PinCandidateGroupNoteMutation($noteId: String!) {
        toggleCandidateGroupNotePin(noteId: $noteId) {
            success
            message
        }
    }
`)

export const AddCandidateGroupNote = gql(/* GraphQL */ `
    mutation AddCandidateGroupNote(
        $candidateIds: [ID!]!
        $companyId: ID
        $rosterId: ID
        $templateId: ID!
        $noteData: String!
        $isPinned: Boolean = false
        $starRating: Float = 0
        $excludeFromEvaluation: Boolean = false
    ) {
        addCandidateGroupNote(
            candidateIds: $candidateIds
            companyId: $companyId
            rosterId: $rosterId
            templateId: $templateId
            noteData: $noteData
            isPinned: $isPinned
            starRating: $starRating
            excludeFromEvaluation: $excludeFromEvaluation
        ) {
            success
            message
        }
    }
`)

export const UpdateCandidateGroupNote = gql(/* GraphQL */ `
    mutation UpdateCandidateGroupNote(
        $candidateIds: [ID!]!
        $companyId: ID
        $rosterId: ID
        $templateId: ID!
        $noteId: ID!
        $noteData: String!
        $isPinned: Boolean = false
        $starRating: Float = 0
        $excludeFromEvaluation: Boolean = false
    ) {
        updateCandidateGroupNote(
            candidateIds: $candidateIds
            companyId: $companyId
            rosterId: $rosterId
            templateId: $templateId
            noteId: $noteId
            noteData: $noteData
            isPinned: $isPinned
            starRating: $starRating
            excludeFromEvaluation: $excludeFromEvaluation
        ) {
            success
            message
        }
    }
`)

export const DeleteCandidateGroupNote = gql(/* GraphQL */ `
    mutation DeleteCandidateGroupNote($noteId: String!) {
        deleteCandidateGroupNote(noteId: $noteId) {
            success
            message
        }
    }
`)
